module.exports = __webpack_public_path__ + "media/assets/images/logo-644380e6c1ad9c2099aa84b56a6cc341.png";